import React from 'react';
import { MenuLeafNode } from './menu-nodes/MenuLeafNode';
import { MenuParentNode } from './menu-nodes/MenuParentNode';
import { I18nUtils } from '../../../../../../../i18n/I18nUtils';
import { PsRoutes } from '../../../../../routing/Routes';

export const MyOutsourcesViewerMenu = () => {
    return (
        <React.Fragment>
            <MenuLeafNode
                icon={'home'}
                label={I18nUtils.tr('TR_INICIO')}
                route={PsRoutes.HOME}
                activeRoutes={[PsRoutes.HOME]}
            />
            <MenuParentNode
                icon={'work_outline'}
                label={I18nUtils.tr('TR_MIS_SUBCONTRATAS')}
                activeRoutes={[
                    PsRoutes.MY_OUTSOURCES,
                    PsRoutes.MY_OUTSOURCES_ADD,
                    PsRoutes.MY_OUTSOURCES_MACHINES,
                    PsRoutes.MY_OUTSOURCES_WORKERS,
                    PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL,
                    PsRoutes.MY_OUTSOURCES_DOCUMENTS,
                    PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_DETAIL,
                    PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE,
                    PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY,
                ]}
            >
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TODAS_LAS_SUBCONTRATAS')}
                    route={PsRoutes.MY_OUTSOURCES}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES, PsRoutes.MY_OUTSOURCES_DETAIL]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_DOCUMENTOS')}
                    route={PsRoutes.MY_OUTSOURCES_DOCUMENTS}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_DOCUMENTS, PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TRABAJADORES')}
                    route={PsRoutes.MY_OUTSOURCES_WORKERS}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_WORKERS, PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_MAQUINARIA')}
                    route={PsRoutes.MY_OUTSOURCES_MACHINES}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_MACHINES, PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL]}
                />
                <MenuParentNode
                    label={I18nUtils.tr('TR_LISTERIAS')}
                    activeRoutes={[
                        PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY,
                    ]}
                >
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_LISTERIA_MENSUAL')}
                        route={PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY}
                        activeRoutes={[PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY]}
                    />
                </MenuParentNode>
            </MenuParentNode>
        </React.Fragment>
    );
};

MyOutsourcesViewerMenu.propTypes = {};

MyOutsourcesViewerMenu.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/menus-by-role/MyOutsourcesViewerMenu.jsx